import Icon from "@ant-design/icons";
import { ReactComponent as MissionSvg } from "./svg/mission.svg";

const MissionIcon = (props) => <Icon component={MissionSvg} {...props} />;

export default MissionIcon;
